import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import CustomIconButton from "@/src/lib/ui/iconButton";

const DeleteTestConfirmationHeader = ({ open, onClose }) => {
    return (
        <div className="flex flex-row items-center justify-between border-b border-gray-200 pb-4 -mx-4 px-4">
            <div className="flex flex-row items-center">
                <p className="text-black font-bold text-lg mr-2">
                    {open?.patientName}
                </p>
                <p className="text-sm text-gray-500 font-medium">
                    {open?.patientAge} /{" "}
                    {open?.patientGender.toLowerCase() === "m"
                        ? "Male"
                        : "Female"}
                </p>
            </div>

            <CustomIconButton
                className="text-primary"
                onClick={onClose}
                width={30}
            >
                <Iconify icon={IconCode.close} size={20} />
            </CustomIconButton>
        </div>
    );
};
export default DeleteTestConfirmationHeader;
